import { PagesizeType } from '../../service/pagination/pagesize-type';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Reservation } from '../../models/reservation';
import { ReservationStore } from '../../service/reservation-store';
import { StaySummary } from '../../models/stay-summary';
import { ReservationStatusCode } from '../../models/reservation-status-code.enum';
import { OnyxEvent } from '../../models/event';
import { ReservationUtils } from '../../utils/reservation-utils';
import { Page } from '../../../shared/models/page';
import { UserLocalStorageService } from '../../../permission/services/user.local.storage.service';
import { Party } from '../../models/party';
import { AuthenticationStore } from 'app/permission/services/authentication.store';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { PaymentSummary } from 'app/event/models/payment-summary/payment-summary';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { ErrorHandlerService } from 'app/shared/utils/error-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { PaymentSummaryStore } from 'app/event/service/payment-summary/payment-summary.store';

@Component({
  selector: 'pioneer-payment-reservations',
  templateUrl: './payment-reservations.component.html'
})
export class PaymentReservationsComponent implements OnInit, OnDestroy {

  public onyxEvent: OnyxEvent;

  @Input()
  public vendor: Party;

  public reservationsPage: Page<Reservation>;
  public staySummary: StaySummary;

  pagesizeType = PagesizeType.PAYMENT_RESERVATIONS;

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  private _destroy$ = new Subject<void>();

  constructor(private reservationStore: ReservationStore,
    private userLocalStorageService: UserLocalStorageService,
    private authenticationStore: AuthenticationStore,
    private paymentSummaryStore: PaymentSummaryStore,
    private errorHandlerService: ErrorHandlerService,
    private translateService: TranslateService,
    ) {
  }

  ngOnInit() {
    this.goToRecordsPage(0);

    this.paymentSummaryStore.getPaymentSummary(this.vendor.eventPartyId)
      .pipe(
        takeUntil(this._destroy$),
        catchError(err => {
          this.errorHandlerService.throw(err.message, this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_PAYMENT_SUMMARY'));
          return Observable.empty();
        }),
        map((paymentSummary: PaymentSummary) => {
          this.staySummary = new StaySummary({
            totalNights: paymentSummary.roomCommissionSummary.totalNights,
            totalRevenue: paymentSummary.roomCommissionSummary.totalSpend,
            avgRoomRate: paymentSummary.roomCommissionSummary.avgRoomRate,
            totalCommission: paymentSummary.roomCommissionSummary.amountDue
          });
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  getCommission(reservation: Reservation): number {
    return reservation ? ReservationUtils.getCommission(reservation, this.vendor) : undefined;
  }

  getCommissionFromStaySummary(staySummary: StaySummary): number {
    return staySummary ? staySummary.totalRevenue * this.vendor.commissionRoomPercentage / 100 : undefined;
  }

  goToRecordsPage(pageNumber: number) {
    this.reservationStore.getReservationsByStatusByParty(this.onyxEvent.eventId, this.vendor.eventPartyId,
      [ ReservationStatusCode.CHECKED_OUT ], pageNumber, this.userLocalStorageService.getPagesize(PagesizeType.PAYMENT_RESERVATIONS))
      .map(page => this.reservationsPage = page )
      .take(1)
      .subscribe();
  }

  isMultiVendor() {
    return this.authenticationStore.hasPermission('MultiVendor');
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/reservations/payment-reservations.component.ts